import log from 'salvo-lite/log'
import HcSticky from 'hc-sticky'
import { getClosest, getHeight } from '../helpers/general'

class Sticky {
    constructor (theme, elem) {
        this._elem = elem
        log.debug(this.constructor.name, 'Constructed', this)
        this._options = {
            top: getHeight(document.querySelector('header')) + 30,
            bottomEnd: 30,
            stickTo: getClosest(elem, '[data-sticky-container]') || elem.parentNode
        }
    }

    onInit () {
        this._sticky = new HcSticky(this._elem, this._options)
    }
}

export default Sticky



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Sticky.js